import styled from "styled-components";
import BadgeBase from "../BadgeBase";
import { RatingBadgeProps } from "./RatingBadge.types";

const StyledRatingBadge = styled(({ ...props }: RatingBadgeProps) => (
	<BadgeBase
		backgroundColor="semantic_warning_100"
		color="semantic_warning_700"
		icon="star"
		iconColor="semantic_warning_400"
		{...props}
	/>
))<RatingBadgeProps>`
	// Brand customisations

	${(props) => props.theme.components.ratingBadge.base}
`;

export default StyledRatingBadge;
